import {useEffect, useState} from 'react';
import yellowstar from '../../assets/images/yellowstar.svg';
import {API} from '../../utils/api';
import {Accordion} from 'react-bootstrap';
import { Helmet } from 'react-helmet';

const Faq = () => {
  const [FAQs, setFAQs] = useState([]);

  useEffect(() => {
    getFAQData();
  }, []);

  const getFAQData = () => {
    API(`faq?type=0`, 'get', '', '')
      .then((res) => {
        setFAQs(res?.data);
        console.log('res?.data', res?.data);
      })
      .catch((e) => console.log('error faq: ', e));
  };

  return (
    <div className="main__page__content ">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Frequently Asked Questions</title>
      </Helmet>
      <main>
        <section className="reg__faq--section">
          <div className="container">
            {/* <div className="reg__faq--reting">
              <a
                href="#"
                className="d-flex d-flex_wrap align-center fsi f20 text-400 lh22 justify-center mb-60"
              >
                <span className="pr-5 f20">Our customers say </span>
                <span className="pr-5 f20 fmp text-700"> Excellent</span>
                <div className="reg__retting--image d-flex pr-5">
                  <img className="in-svg" src={yellowstar} alt="" />
                  <img className="in-svg" src={yellowstar} alt="" />
                  <img className="in-svg" src={yellowstar} alt="" />
                  <img className="in-svg" src={yellowstar} alt="" />
                  <img className="in-svg" src={yellowstar} alt="" />
                </div>
                <span className="fmp f20 text-700 pr-5">4.94</span>
                <span className="pr-5 f20">out of 5 based on</span>
                <span className="fmp pr-5 f20 text-700">7885</span>
                <span className="f20">reviews</span>
              </a>
            </div> */}
            <div className="faq__heading">
              <h1 className="fys text-300 f36 mb-15">
                Frequently Asked Questions
              </h1>
              <p className="fsi text-400 mb-30">
                We are here to make the buying process as easy as possible. If
                you have a question which is not answered here, be sure to send us
                an email so we can assist!
              </p>
            </div>
            <Accordion defaultActiveKey={0}>
              {FAQs?.map((item, index) => (
                <Accordion.Item
                  eventKey={index}
                  className="accordion-item border-0 shadow mb-15 bg-body rounded">
                  <Accordion.Header className="accordion-header" id="work">
                    {item?.question}
                  </Accordion.Header>
                  <Accordion.Body
                    id={`workdata${index}`}
                    className="accordion-collapse fsi ms-4">
                    <span
                      className='f16'
                      dangerouslySetInnerHTML={{
                        __html: item?.answer?.replace('rel="noopener" rel="noreferrer" target="_blank"', ''),
                      }}></span>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
            {/* <div className="accordion" id="accordionExample">
                        {FAQs?.map((item, index) => (
                          <div className="accordion-item border-0 shadow mb-15 bg-body rounded">
                          <h2 className="accordion-header" id="work">
                            <button className={index === 0 ? "accordion-button fsi f16 text-400 lh24 p-3" : "accordion-button  fsi f16 text-400 lh24 collapsed p-3"} type="button" data-bs-toggle="collapse" data-bs-target={`#workdata${index}`} aria-expanded="true" aria-controls="collapseOne">
                                {item?.question}
                            </button>
                          </h2>
                          <div id={`workdata${index}`} className={index === 0 ? "accordion-collapse collapse show fsi" : "accordion-collapse collapse fsi"} aria-labelledby="work" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              {item?.answer}
                            </div>
                          </div>
                        </div>
                        ))}
                    </div> */}
            {/* <a
              href="#"
              className="reg__addi--ques mt-4 text-center f16 d-block">
              Need additional assistance or want to ask a question? Let us know
              how we can help you.
            </a> */}
          </div>
        </section>
      </main>
    </div>
  );
};

export default Faq;
